import { FareFamilyApiResponse, FlightRequest } from '@/src/components/desktop/srp/fareFamily/types'
import { getCurrentLocale } from '@/src/utils/rtkQuery/getCurrentLocale'
import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
    prepareHeaders: headers => {
        const locale = getCurrentLocale()
        headers.set('Accept', 'application/json')
        headers.set('Content-Type', 'application/json')
        headers.set('X-CT-SOURCETYPE', 'web')
        headers.set('preferred-language', locale)
        return headers
    }
})

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 })

const SrpFareFamilyApi = createApi({
    reducerPath: 'SrpFareFamilyApi',
    baseQuery: baseQueryWithRetry,
    tagTypes: ['fareFamily'],
    endpoints: builder => ({
        srpFareFamily: builder.query<FareFamilyApiResponse, FlightRequest>({
            query: body => ({
                url: '/flight/search/v2/fare-family/get-info',
                method: 'POST',
                body
            }),
            providesTags: (_result, _error, request) => [
                { type: 'fareFamily', id: request?.flightParams[0]?.onwardFares[0]?.fareKey }
            ]
        })
    })
})

export const { useSrpFareFamilyQuery, useLazySrpFareFamilyQuery } = SrpFareFamilyApi
export default SrpFareFamilyApi
